import { ComponentsManager } from '../core/smpl-components'
// import { componentRegistry } from '../config/components-registry'

const componentRegistry = [
	{
		file: 'hero',
		selector: '.js-hero',
		name: 'hero',
	},
	{
		file: 'logos',
		selector: '.js-logos',
		name: 'logos',
	},
	{
		file: 'footer-nav',
		selector: '.js-footer-nav',
		name: 'footer-nav',
	},
	{
		file: 'image-switcher',
		selector: '.js-image-switcher',
		name: 'image-switcher',
	},
	{
		file: 'main-nav',
		selector: '.js-main-nav',
		name: 'main-nav',
	},
	{
		file: 'fade-slider',
		selector: '.js-fade-slider',
		name: 'fade-slider',
	},
	{
		file: 'lines-animation',
		selector: '.js-lines-animation',
		name: 'lines-animation',
	},
	{
		file: 'milestones-timeline',
		selector: '.js-milestones-timeline',
		name: 'milestones-timeline',
	},
	{
		file: 'mixed-use-ui',
		selector: '.js-mixed-use-ui',
		name: 'mixed-use-ui',
	},
	{
		file: 'form-submit',
		selector: '.js-form-submit',
		name: 'form-submit',
	},
	{
		file: 'body',
		selector: 'body',
		name: 'body',
	},
	{
		file: 'video-embed',
		selector: '.js-video-embed',
		name: 'video-embed',
	},
]

// ...existing code...
export const initComponents = (ctx) => {
	ComponentsManager.setup({
		debug: false,
		components: componentRegistry,
		eventBus: ctx.eventBus,
	})

	// window.ComponentsManager = ComponentsManager
	ctx.componentsManager = ComponentsManager

	//
	// document.addEventListener(
	//     'DOMContentLoaded',
	//     () => {
	//         manager.init()
	//     },
	//     { once: true }
	// )

	return ComponentsManager
}
